import login_bg from "../../assets/images/login_bg.png";
import bg_opacity from "../../assets/images/bg_opacity.png";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

const Logout = ({ isOpen, onClose }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = () => {
        try {
            // dispatch(logOutUser());
            localStorage.removeItem("accessToken");
            localStorage.clear();
            toast.success("Admin Logout Successfully...!");
            navigate("/");
            window.location.reload();
        } catch (error) {
            console.log("error", error);
        }
    }

    const handleCancel = () => {
        navigate("/users-analytics");
        window.location.reload();
    }

    if (!isOpen) return null;
    return (
        <section className="logout_modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-[9999]">
            <img src={login_bg} alt="login_bg" className="absolute inset-0 w-full h-full object-cover" />
            <img src={bg_opacity} alt="login_bg" className="absolute inset-0 w-full h-full object-cover" />

            <div className="relative w-[500px] lg:w-[550px] bg-white rounded-[30px] shadow-lg px-5 lg:px-8 py-6 lg:py-8 m-4 md:m-0 z-20">
                <div className="absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2 w-[114px] xl:w-[126px] h-[110px] xl:h-[132px] rounded-full bg-white p-5">
                    <div className="w-16 xl:w-20 h-16 xl:h-20 mx-auto">
                        <img src={logo} alt="Logo" className="w-full h-full rounded-full object-cover" />
                    </div>
                </div>
                <div className="text-center mt-7 xl:mt-9">
                    <h2 className="text-18 xl:text-20 font-extrabold text-text_1">Logout</h2>
                    <span className="block text-28 sm:text-32 xl:text-40 font-extrabold text-primary tracking-wider xl:tracking-widest py-3.5 lg:py-7">Are You Sure?</span>
                </div>
                <div className="w-full flex items-center justify-center space-x-3 mt-4">
                    <button type="button" className="block w-1/2 text-base sm:text-lg font-bold whitespace-nowrap text-text_1 bg-white anim border border-gray_2 outline-none cursor-pointer rounded-lg py-2.5 sm:py-3.5" onClick={handleCancel}>Cancel</button>
                    <button type="button" className="block w-1/2 text-base sm:text-lg font-bold whitespace-nowrap text-white hover:border-primary hover:text-primary bg-primary hover:bg-white border outline-none cursor-pointer rounded-lg py-2.5 sm:py-3.5 anim" onClick={handleLogout}>Logout</button>
                </div>
            </div>
        </section>
    )
}

Logout.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

export default Logout;